import React, { useEffect, useState } from "react";
import { Text, View, Image, Pressable } from "react-native";

import { getImagePath } from "../../utils/services/CommonUtils";
import { getTimeRange } from "../../utils/services/DateTimeUtils";
import { getChemistProfilePicUrl, getStoreMaxDiscount } from "../../utils/services/chemist/ChemistStoreUtils";

import { CommonHeader } from "../../utils/widgets/CommonWidget/CommonHeader";

import { HorizontalDivider } from "../../utils/widgets/Common-Widget";
import {
    ChemistStoreInformation, ChemistStoreServices, StaticPaymentModes,
    StorePicturesCarouselPagination, StorePictureView
} from "../../utils/widgets/chemist/ChemistStoreWidget";

import { IndiaRupee } from "../../utils/constants/AppConstants";
import { ScreenRoute } from "../../utils/constants/ScreenRouteConstant";

import AppTheme from "../../AppTheme";
import AppStyles from "../../AppStyles";
import TextStyle from "../../TextStyle";
import Colors from "../../utils/constants/AppColors";

import CustomCarousel from "../../utils/widgets/Carousel/CustomCarousel";

const ChemistStoreProfile = (props) => {

    const chemistStoreData = props?.route?.params?.chemistStoreData
    const chemistStoreSetting = chemistStoreData['storeSettings']

    const [chemistStorePictures, setChemistStorePicture] = useState([])
    const [maxStoreDiscount, setStoreDiscount] = useState({ 'discount': 0, mtype: '' })

    const getChemistStorePictures = (chemistStoreData) => {
        if (chemistStoreData['storePicturesV2'] &&
            chemistStoreData['storePicturesV2'].length)
            setChemistStorePicture(chemistStoreData['storePicturesV2'])
    }

    useEffect(() => {
        var maxStoreDiscount = getStoreMaxDiscount(chemistStoreSetting['discounts'])
        setStoreDiscount(maxStoreDiscount)
        getChemistStorePictures(chemistStoreData)
    }, [])

    const getStoreTimingText = (storeTiming) => {
        return <Text style={[TextStyle.text14xb]}>
            Store Timings - <Text style={[TextStyle.text12, { color: Colors.grey.lightText }]}>
                {getTimeRange(storeTiming['start'], storeTiming['end'])}</Text></Text>
    }

    const getStoreDiscountTitle = () => {
        const discount = maxStoreDiscount['discount']
        const product = maxStoreDiscount['mtype']
        return <Text style={[TextStyle.text14xb]}>
            Up to {discount}% OFF <Text style={[TextStyle.text14]}>
                on</Text> {product}</Text>
    }

    const getHomeDeliveryTextWithMinOrderAmount = (storeSetting) => {
        return chemistStoreSetting['minOrderAmountHomeDelivery'] > 0 ?
            <Text style={[TextStyle.text14]}>
                Free <Text style={[TextStyle.text14xb]}>Home Delivery
                </Text> for orders above {IndiaRupee}{storeSetting['minOrderAmountHomeDelivery']}</Text> :
            <Text style={[TextStyle.text14]}>
                Free Home Delivery</Text>
    }

    const getStorePaymentModes = () => {
        return <Text style={[TextStyle.text14xb]}>
            Payment modes accepted</Text>
    }

    const previewStorePicture = (storePicData, index) => {
        var imageUrlList = []
        storePicData.forEach((picture) => {
            imageUrlList.push({ imageUrl: picture['publicUrl'] })
        })
        props.navigation.navigate(ScreenRoute.images_preview,
            { imageList: imageUrlList, startIndex: index })
    }

    const previewChemistProfilePicture = (storeData) => {
        var imageUrlList = [{ imageUrl: getChemistProfilePicUrl(storeData) }]
        props.navigation.navigate(ScreenRoute.images_preview,
            { imageList: imageUrlList })
    }

    return (<View style={{ paddingBottom: 24 }}>

        <CommonHeader title={'About Store'} navigation={props.navigation} />

        <View style={{ marginTop: AppTheme.headerHeight }}>
            <View style={{ marginBottom: 44 }}>
                {chemistStorePictures.length ?
                    <CustomCarousel carouselData={chemistStorePictures}
                        carouselViewBuilder={StorePictureView}
                        paginationViewBuilder={StorePicturesCarouselPagination}
                        scallingFactorOffset={AppTheme.appWidth}
                        viewWidth={AppTheme.appWidth} viewHeight={180}
                        callback={(storePicData, index) =>
                            previewStorePicture(storePicData, index)} /> :
                    <Image style={{ width: AppTheme.appWidth, height: 180 }}
                        source={{ uri: getImagePath('/images/chemistStore/chemistStorePic.png') }} />}
                <Pressable style={[AppStyles.bgWhite, AppStyles.borderViewRound, {
                    position: "absolute", left: 14, bottom: -40,
                    padding: 2, width: 80, height: 80
                }]} onPress={() => previewChemistProfilePicture(chemistStoreData)}
                onLongPress={() => { console.log('### long press') }}>
                    <Image style={{ width: 76, height: 76, borderRadius: 38 }}
                        source={{ uri: getChemistProfilePicUrl(chemistStoreData) }} />
                </Pressable>
            </View>

            <View style={[AppStyles.flexRowStart, { marginHorizontal: 16 }]}>
                <Text style={[TextStyle.text18xb, { maxWidth: AppTheme.appWidth - 124, paddingRight: 0 }]}
                    numberOfLines={1} ellipsizeMode={'head'} >
                    {chemistStoreData['pharmacyName']}</Text>
                <Image style={{ marginLeft: 4, height: 16, width: 16 }}
                    source={{
                        uri: getImagePath('/images/icons/tick_circle_green.svg')
                    }} />
            </View>


            <View style={[AppStyles.flexRowStart, { marginHorizontal: 16, paddingTop: 4 }]}>
                <Image style={{ height: 14, width: 14 }}
                    source={{
                        uri: getImagePath('/images/icons/url_link.svg')
                    }} />
                <Text style={[TextStyle.text14, {
                    maxWidth: AppTheme.appWidth - 124,
                    marginLeft: 4, color: Colors.grey.text
                }]} numberOfLines={1} ellipsizeMode={'head'} >
                    {chemistStoreData['siteDomain']}</Text>
            </View>

            <HorizontalDivider width={AppTheme.appWidth} marginVertical={16} />

            <View style={[{ marginHorizontal: 16 }]}>
                <ChemistStoreInformation informationIcon={'/images/icons/location/grey.svg'}
                    informationTitle={chemistStoreData['address']} />
                {chemistStoreData['phoneNumber'] && <ChemistStoreInformation informationIcon={'/images/icons/call/grey.svg'} marginTop={8}
                    informationTitle={chemistStoreData['phoneNumber']} />}
            </View>

            <HorizontalDivider width={AppTheme.appWidth} marginVertical={16} />

            <View style={[{ marginHorizontal: 16 }]}>
                <ChemistStoreServices serviceIcon={'/images/chemistStore/time.svg'}
                    customView={getStoreTimingText(chemistStoreSetting['timing'])} />
                {maxStoreDiscount.discount > 0 &&
                    <ChemistStoreServices serviceIcon={'/images/chemistStore/discount.svg'}
                        customView={getStoreDiscountTitle()} />}
                {chemistStoreSetting['isProvidingHomeDelivery'] ?
                    <ChemistStoreServices serviceIcon={'/images/chemistStore/home.svg'}
                        customView={getHomeDeliveryTextWithMinOrderAmount(chemistStoreSetting)} /> : null}
                <ChemistStoreServices serviceIcon={'/images/chemistStore/payment.svg'}
                    customView={getStorePaymentModes()} />
            </View>

            <View style={{ marginHorizontal: 38 }}>
                <StaticPaymentModes /></View>

        </View>

    </View>)
}

export default ChemistStoreProfile